<!-- success.component.html -->

<mat-card>
    <mat-card-header>
        <mat-card-title>
            <div class="flex justify-start items-center">
                <mat-icon class="failed">cancel</mat-icon>
                <div class="ml-5 text-red text-2xl font-semibold">Payment Failed!</div>
            </div>
        </mat-card-title>
    </mat-card-header>
    <mat-card-content class="my-10 text-lg">
        <div>
            <p class="mb-3">Your payment has not been processed.</p>
            <p>Please retry again...</p>
        </div>
        <!-- <div *ngIf="!isLoading &&  paymentInfo.isPaid && paymentInfo.txn_id !== 'exempted'">
            <p class="mb-3">Your payment with Transaction ID: <span class="font-bold text-lg">{{ paymentInfo.txn_id }} </span>has been successfully processed.</p>
            <p>Thank you for submitting your application!</p>
        </div> -->
    </mat-card-content>
    <mat-card-actions>
        <button mat-button color="primary" routerLink="/certifications">Go to Listing page</button>
    </mat-card-actions>
</mat-card>